"use client";

import { Skeleton } from "@saridana-core/react-ui-kit";

export function FallbackSection() {
  return (
    <div className="min-h-[500px] relative overflow-hidden">
      <Skeleton className="absolute top-0 left-0 w-full h-full" />
    </div>
  );
}
